export default __webpack_public_path__ + "1cad4e8f2ec89085198f13694ae52a30.png";